export const OC_PRODUCT_AVAILABILITY = {
  desktop: `<div style="background-color: #F7F7F7; height: 100vh;">
  <div class="cui-skeleton-rectangle -is--block">
    <div class="cui-skeleton__item" style="width: 100vw; height: 80px;"></div>
  </div>
  <main>
    <div style="background-color: white;">
      <div class="cui cui-grid cui-container">
        <div class="cui-row">
          <div class="cui-col">
            <div class="-spacing--top-64 cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 515px; height: 55px; border-radius: 16px;"></div>
            </div>
            <div class="-spacing--top-40 cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: min(1440px, 100%); height: 128px; border-radius: 16px;"></div>
            </div>
            <div class="-spacing--top-40 -spacing--bottom-64 cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: min(1440px, 100%); height: 128px; border-radius: 16px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cui cui-grid cui-container">
      <div class="cui-row -gap--h-40">
        <div class="cui-col">
          <div class="-spacing--top-64 cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 80px; height: 45px; border-radius: 16px;"></div>
          </div>
          <div class="-spacing--top-12 cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 75px; border-radius: 16px;"></div>
          </div>
          <div class="-spacing--top-12 cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 75px; border-radius: 16px;"></div>
          </div>
          <div class="-spacing--top-12 cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 75px; border-radius: 16px;"></div>
          </div>
          <div class="-spacing--top-12 cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 75px; border-radius: 16px;"></div>
          </div>
        </div>
        <div class="cui-col">
          <div class="-spacing--top-64 cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 272px; height: 45px; border-radius: 16px;"></div>
          </div>
          <div class="-spacing--top-16 cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 272px; height: 18px; border-radius: 16px;"></div>
          </div>
          <div class="-spacing--top-16 cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 272px; height: 18px; border-radius: 16px;"></div>
          </div>
          <div class="-spacing--top-16 cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 272px; height: 18px; border-radius: 16px;"></div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <div class="cui-skeleton-rectangle -is--block">
    <div class="cui-skeleton__item" style="width: 100vw; height: 80px; position: absolute; bottom: 0;"></div>
  </div>
</div>`
};
